import React from 'react';
import Layout from '../../components/Layout';
import ProductInfoSection from './ProductInfoSection';
import ProductFeatureSection from './ProductFeatureSection';
import HeroWithBackgroundImage from '../../components/shared/HeroWithBackgroundImage';
import LearnMoreSection from '../../components/shared/LearnMoreSection';
import TryHoverTodaySection from '../../components/shared/TryHoverTodaySection';
import HeroImage from '../../images/product-hero-1.webp';

const Product = () => (
  <Layout
    title="Home Measurement App Creates a 3D Model from Photos"
    description="HOVER is a measurement app that provides detailed exterior measurements to quote any project. Create a 3d Model from smartphone photos for easy designs. We provide you with all exterior measurements including roof, siding, windows, doors, brick, stone, trim and all other material types."
  >
    <HeroWithBackgroundImage
      height="40vh"
      imageUrl={HeroImage}
      title="The Easiest Way to the Most Accurate Estimates"
      description="Measure, design, and estimate your exterior home improvement projects in one place."
      buttonText="Start Free Trial"
      ctaLink="/signup/"
    />
    <ProductInfoSection />
    <LearnMoreSection ctaLink="/transform-plan?utm_source=Website%20Module&utm_medium=0&utm_campaign=Transform%20IMC_Announcement&utm_term=0&utm_content=0_0_0" />
    <ProductFeatureSection />
    <TryHoverTodaySection
      title="Start Using HOVER"
      description="If you’re impressed with these features, you have a lot more to be excited about."
      buttonText="Get Started"
    />
  </Layout>
);

export default Product;
